import { Col, Form, List, Radio, Row, Typography } from "antd";
import React from "react";
import { abstractionFields } from "../../../../Options/physioOptions";
import { DislikeOutlined, LikeOutlined } from "@ant-design/icons";

const Abstraction = ({ psych = false, setAbstraction }) => {
  const handleChange = (value, fieldValue) => {
    setAbstraction((prev) => ({
      ...prev,
      [fieldValue]: value,
    }));
  };
  return (
    <>
      <List
        bordered={false}
        className="moca-section-card moca-memory-list"
        style={{
  width: "100%",
  maxWidth: psych ? "100%" : "600px",
  margin: "0 auto",
  padding: "20px",
}}
        dataSource={abstractionFields}
        renderItem={(field) => (
          <List.Item>
            <Row style={{ width: "100%" }} align="middle">
              <Col xs={24} md={12} className="moca-abstraction-label-col">
                <Typography className="moca-abstraction-label">
                  <Typography.Text>{field.label}</Typography.Text>
                  <br />
                  <Typography.Text strong>{field.sequence}</Typography.Text>
                </Typography>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name={
                    psych === true
                      ? ["moca", "abstraction_data", field.value]
                      : ["abstraction_data", field.value]
                  }
                  style={{ marginBottom: 0 }}
                >
                  <Radio.Group
                    style={{ width: "100%" }}
                    onChange={(e) => handleChange(e?.target?.value, field.value)}
                  >
                    <Row
                      className="moca-abstraction-yesno-row"
                      justify="end"
                      gutter={12}
                    >
                      <Col>
                        <Radio.Button value={"yes"} className="like-btn">
                          <LikeOutlined />
                        </Radio.Button>
                      </Col>
                      <Col>
                        <Radio.Button value={"no"} className="dislike-btn">
                          <DislikeOutlined style={{ backgroundColor: "" }} />
                        </Radio.Button>
                      </Col>
                    </Row>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </List.Item>
        )}
      />
    </>
  );
};

export default Abstraction;
